import React, { Component } from "react";
import core from "./../common/core";
import OutsideNotifier from "./outsideNotifier";
import { connect } from "react-redux";
import { pullToRefresh, showHideOverlay } from "./../redux/actions/appActions";
import { withRouter } from "react-router-dom";
import app from "../common/app";
import config from "../common/config";

class Overlay extends Component {
  state = {
    isRemove: false,
  };
  windowOffset = 0;
  jbottom = 0;
  overlayRef = React.createRef();
  UNSAFE_componentWillMount() {
    this.windowOffset = window.scrollY;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.isShow && this.props.isShow) {
      core.addClassToElement(document, "body", "bodyNoScroll", true);
    } else if (nextProps.isShow && !this.props.isShow) {
      core.addClassToElement(document, "body", "bodyNoScroll", false);
    }
  }
  componentWillUnmount() {
    if (!(this.props.isFromPlayerPopup /* && config.BrowserDetect.iOS() */)) {
      core.addClassToElement(document, "body", "bodyNoScroll", true);
    }
    window.scrollTo(0, this.windowOffset);
    /* if (this.$body) {
      this.$body.removeEventListener('touchstart', (this.handleClickOutsideTimeOut));
      this.$body.removeEventListener('touchmove', (this.handleClickOutsideTimeOut));
    } */
    this.props.pullToRefresh({ isShowPullToRefresh: true });
    // window.onpopstate = (e) => {};
  }
  componentDidMount() {
    if (!(this.props.isFromPlayerPopup /* && config.BrowserDetect.iOS() */)) {
      core.addClassToElement(document, "body", "bodyNoScroll", false);
    }
    if (this.overlayRef) {
      const $headWarpper = this.overlayRef.current;
      if ($headWarpper) {
        const height = $headWarpper.offsetHeight - 8;
        this.jbottom = height;

        /* this.$body = $headWarpper.querySelector && $headWarpper.querySelector('.m11c-overlay__body');
        if (this.$body) {
          this.$body.addEventListener('touchstart', (this.handleClickOutsideTimeOut));
          this.$body.addEventListener('touchmove', (this.handleClickOutsideTimeOut));
        } */
        this.props.pullToRefresh({ isShowPullToRefresh: false });
      }
    }
  }

  componentDidUpdate(preProps, prestate) {
    // const { history = null, showHideAlert, isShow } = this.props;
    // let reUrl = window.location.pathname.replace(config.BASE_DOMAIN, "");
    // if (showHideAlert) {
    //   history.listen((loc, action) => {
    //     if (action == "POP") {
    //       const sSearch = app.getUTMParameters();
    //       history.push(`${config.URL_BASE}${reUrl}${sSearch}`);
    //       showHideAlert();
    //     }
    //   });
    // }
    // if (showHideAlert) {
    //   window.onpopstate = (e) => {
    //     e.stopPropagation();
    //     e.preventDefault();
    //     const sSearch = app.getUTMParameters();
    //     history.push(`${config.URL_BASE}${reUrl}${sSearch}`);
    //     showHideAlert();
    //   };
    // }
  }

  handleClickOutsideTimeOut = (e) => {
    if (this.$body && this.$body.scrollTop) {
      e.stopPropagation();
    }
  };
  render() {
    let overlayHeight = 0;
    if (this.jbottom) {
      overlayHeight = this.jbottom - 22;
    }
    let sClass = "in out";
    const {
      isShow,
      wrapperClass,
      className,
      nodeAlert,
      toastMessage,
      showHideAlert,
      children,
      abandonedClass,
      rHeight,
    } = this.props;
    let sActiveClass = "";
    if (nodeAlert) {
      sActiveClass = "m11c-active";
    }
    if (toastMessage) {
      // sActiveClass = "m11c-active";
    }
    if (isShow) {
      sClass = "in";
    }
    return (
      <div
        className={`m11c-overlay__wrap m11c-fade ${wrapperClass} ${sClass} ${sActiveClass}`}
      >
        {nodeAlert}
        {/* {toastMessage ? (
          <div
            className="m11c-toast__wrap m11c-success"
            style={{ bottom: overlayHeight + "px" }}
          >
            <div className="m11c-toast__title">
              <span>{toastMessage}</span>
            </div>
          </div>
        ) : null} */}
        <OutsideNotifier
          className={`m11c-overlay__container ${className} ${abandonedClass} ${rHeight}`}
          ref1={this.overlayRef}
          handler={() => {
            showHideAlert && showHideAlert();
          }}
        >
          {children}
        </OutsideNotifier>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    pullToRefresh: (payload) => {
      return dispatch(pullToRefresh(payload));
    },
    showHideOverlay: (payload) => dispatch(showHideOverlay(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Overlay);
